import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientAPI } from "./axiosAnstance";
import axios from "axios";
import { SERVER_URL } from "../../../serverConfig";
import { getAuthHeader } from "../../../jwt/config";
import fileDownload from "js-file-download";

// --- THUNKS ---

// MODIFIÉ : Ajout de la pagination
export const listHajjDemandeAPI = createAsyncThunk(
  "hajj/listHajjDemandeAPI",
  async ({ page = 0, size = 10 } = {}, thunkAPI) => {
    try {
      const url = `/api/hajj/getDemandes?page=${page}&size=${size}`;
      const response = await clientAPI.get(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// MODIFIÉ : Filtre avec pagination
export const listDemandeFilterHajjAPI = createAsyncThunk(
  "hajj/listDemandeFilterHajjAPI",
  async (data, thunkAPI) => {
    try {
      // Extraction pagination
      const page = data.page || 0;
      const size = data.size || 10;

      // Séparation des filtres
      const filters = { ...data };
      delete filters.page;
      delete filters.size;


      const url = `/api/hajj/filter?page=${page}&size=${size}`;
      const response = await clientAPI.post(url, filters);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const traiteDemandeHajjAPI = createAsyncThunk(
  "hajj/traiteDemandeHajjAPI",
  async ({ id }, thunkAPI) => {
    try {
      const url = `/api/hajj/traiteDemande/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const listHajjDemandeTraiteAPI = createAsyncThunk(
  "hajj/listHajjDemandeTraiteAPI",
  async (data) => {
    const url = `/api/hajj/listeDemandeTraite`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);

export const updateRibHajjAPI = createAsyncThunk(
  "soutient/updateRibHajjAPI",
  async (data, thunkAPI) => {
    try {


      // Construire l'URL avec les paramètres de pagination
      const url = `/api/hajj/updateRib`;

      const response = await clientAPI.post(url, data);
      return response.data;
    } catch (error) {
      console.error('Erreur API filtres:', error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const incompteteHajjAPI = createAsyncThunk(
  "hajj/incompteteHajjAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/hajj/icompleteDemande", formData);
    return response.data;
  }
);

export const saveDemandeHajjAPI = createAsyncThunk(
  "hajj/saveDemandeHajjAPI",
  async (data) => {
    try {
      const response = await clientAPI.post("/api/hajj/saveDemande", data);
      return response.data;
    } catch (error) {
      return 'il est un probléme au niveau de la API';
    }
  }
);

export const valideDemandeHajjAPI = createAsyncThunk(
  "hajj/valideDemandeHajjAPI",
  async ({ id, action }, thunkAPI) => {
    try {
      const url = `/api/hajj/valide/${id}`;
      const response = await clientAPI.post(url);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const refuserHajjAPI = createAsyncThunk(
  "hajj/refuserHajjAPI",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/hajj/refusDemande", formData);
    return response.data;
  }
);

export const listTypeFichierSavedHajjAPI = createAsyncThunk(
  "hajj/listTypeFichierSavedHajjAPI",
  async (idDemande) => {
    const response = await clientAPI.get("/api/hajj/listeTypeFichierSaved/" + idDemande);
    return response.data;
  }
);

export const getFileByDemandeAndTypeHajj = createAsyncThunk(
  "hajj/getFileByDemandeAndTypeHajj",
  async (data) => {
    return axios
      .get(
        SERVER_URL +
        `/api/hajj/getFileByDemandeAndType/${data.idDemande}/${data.id_type_fichier}`,
        {
          headers: getAuthHeader(),
          responseType: "blob",
        }
      )
      .then((res) => {
        return res.data;
      });
  }
);

export const saveFichierHajjAPI = createAsyncThunk(
  "hajj/saveFichierHajjAPI",
  async (data) => {
    const fichi = JSON.stringify(data.toSave);
    const blob = new Blob([fichi], { type: "application/json" });
    var formData = new FormData();
    var theFile = data.file;

    formData.append("file", theFile);
    formData.append("fileMeta", blob);
    let token = localStorage.getItem("token");

    const response = axios.post(SERVER_URL + `/api/hajj/saveFichier`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      Accept: "application/json",
    });
    return (await response).data;
  }
);

// AJOUTÉ : Fonction d'exportation
export const downloadExportHajjAPI = createAsyncThunk(
  "hajj/exportData",
  async (data) => {
    const token = localStorage.getItem("token");
    const d = new Date();
    const datestring =
      ("0" + d.getDate()).slice(-2) + "-" +
      ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
      d.getFullYear() + "_" +
      ("0" + d.getHours()).slice(-2) +
      ("0" + d.getMinutes()).slice(-2);

    const response = await axios.post(
      `${SERVER_URL}/api/hajj/export-data`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    fileDownload(response.data, `Pelerinage-${datestring}.xlsx`);
  }
);

// --- SLICE ---

const HajjSlice = createSlice({
  name: "hajj",
  initialState: {
    listeDemande: [],
    listeDemandeTraite: [],
    listeTypeFichierSaved: [],
    // MODIFIÉ : Métadonnées de pagination
    totalElements: 0,
    pageNumber: 0,
    pageSize: 10,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // LISTE PAGINÉE
      .addCase(listHajjDemandeAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listHajjDemandeAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemande = action.payload.content;
        state.totalElements = action.payload.totalElements;
        state.pageNumber = action.payload.number;
        state.pageSize = action.payload.size;
      })
      .addCase(listHajjDemandeAPI.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // FILTRE PAGINÉ
      .addCase(listDemandeFilterHajjAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(listDemandeFilterHajjAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemande = action.payload.content;
        state.totalElements = action.payload.totalElements;
        state.pageNumber = action.payload.number;
        state.pageSize = action.payload.size;
      })
      .addCase(listDemandeFilterHajjAPI.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // AUTRES
      .addCase(listHajjDemandeTraiteAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeDemandeTraite = action.payload;
      })
      .addCase(listTypeFichierSavedHajjAPI.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.listeTypeFichierSaved = action.payload;
      });
  },
});

export const {} = HajjSlice.actions;

export default HajjSlice.reducer;
